export function arePricesAndDiscountsDifferent(product, otherProduct, withoutVAT = false) {
    const price = withoutVAT ? "price" : "priceWT";
    const discountedPrice = withoutVAT ? "discountedPrice" : "discountedPriceWT";
    return product && otherProduct &&
        (product[price] !== otherProduct[price] ||
            product.discount !== otherProduct.discount ||
            product[discountedPrice] !== otherProduct[discountedPrice]);
}